<template>
  <div class="tableBox11">
      <div class="box11Title">风险研判</div>
      <el-table
        :data="tableData"
        border
        style="width: 98%;margin: auto; height: 243px"
        :header-cell-style="{padding: '9px 3px'}"
        :cell-style="{padding: '8px 3px'}">
        <el-table-column
          prop="no"
          label="编号">
        </el-table-column>
        <el-table-column
          prop="name"
          label="名称">
        </el-table-column>
        <el-table-column
          prop="nickname"
          label="上报人">
        </el-table-column>
        <el-table-column
          prop="gtmCreate"
          label="创建时间">
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="expireBox">
        <el-pagination
          small
          layout="prev, pager, next" @current-change="handleChange"
          :total="total" :current-page="curPage" :page-size="limit">
        </el-pagination>
      </div>
    </div>
</template>

<script>
import { getFxypList } from "@/api/earlyWarning"
export default {
  name: "fxyp",
  data() {
    return {
      tableData: [],
      curPage: 1,
      total: 0,
      limit: 5
    }
  },
  methods: {
    getList() {
      getFxypList({ limit: this.limit, curPage: this.curPage }).then(res => {
        // console.log(res)
        this.tableData = res.body.data
        this.total = res.body.cum
      })
    },
    handleChange(val){
      this.curPage = val
      this.getList()
    }
  },
  created() {
    this.getList()
  }
}
</script>

<style scoped>
  .tableBox11 {
    width: 49%;
    height: 300px;
    border: 1px solid rgb(232,232,232);
    margin-right: 1%;
    margin-bottom: 10px;
  }
  .box11Title {
    padding-left: 8px;
    font-weight: 600
  }
  .expireBox {
    text-align: right;
    margin-top: 3px
  }
</style>